import { MovieOpenIcon } from './MovieOpenIcon';

/**
 * author: GreenTurtwig
 * id F23718ED-A1EE-42D7-84B2-773E110AAB63
 * name movie-open
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/movie-open.svg
 * tags
 * - Video / Movie 
 */
export const FilmOpenIcon = MovieOpenIcon;
export default FilmOpenIcon